import { Film } from "lucide-react";
import { posterUrl } from "@/lib/api";

export const STATUS_INFO = {
  liked: { label: "Liked", color: "--sp-up" },
  disliked: { label: "Didn't like", color: "--sp-down" },
  watchlist: { label: "Watchlist", color: "--sp-right" },
  passed: { label: "Not interested", color: "--sp-left" },
};

export function SearchResultRow({ movie, index, onOpen }) {
  const info = STATUS_INFO[movie.status];
  return (
    <li style={{ animationDelay: `${index * 25}ms` }} className="fade-up">
      <button onClick={() => onOpen(movie)} data-testid={`search-result-${movie.movie_id}`}
        className="w-full flex items-center gap-4 p-3 rounded-2xl border bg-card text-left transition-colors hover:border-foreground/25">
        {movie.poster_path ? (
          <img src={posterUrl(movie.poster_path, "w154")} alt="" loading="lazy" className="h-20 w-14 rounded-lg object-cover shrink-0" />
        ) : (
          <span className="h-20 w-14 rounded-lg bg-secondary flex items-center justify-center shrink-0"><Film className="h-5 w-5 text-muted-foreground" /></span>
        )}
        <span className="min-w-0 flex-1">
          <span className="block font-display font-bold leading-tight truncate">{movie.title}</span>
          <span className="block text-xs text-muted-foreground mt-0.5">{movie.year || "—"} · {movie.genres.slice(0, 2).join(", ") || "—"}</span>
        </span>
        {info ? (
          <span data-testid={`search-status-${movie.movie_id}`}
            className="shrink-0 text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full"
            style={{ color: `hsl(var(${info.color}))`, background: `hsl(var(${info.color}) / 0.12)` }}>
            {info.label}
          </span>
        ) : (
          <span className="shrink-0 text-xs font-semibold text-primary" data-testid={`search-rate-${movie.movie_id}`}>Rate</span>
        )}
      </button>
    </li>
  );
}
